import { createSlice, createSelector } from '@reduxjs/toolkit'
import { HYDRATE } from 'next-redux-wrapper'

const users = createSlice({
  name: 'users',
  initialState: {
    optionsPerFilter: {
      roles: []
    },
    query: {},
    users: [],
    count: 0,
    pageState: {
      initialLoad: true,
      refresh: false
    }
  },
  reducers: {
    SET: (state, { payload }) => {
      const { users, count, query } = payload
      return { ...state, users, count, query }
    },
    SET_PAGE_STATE: (state, { payload }) => {
      state.pageState = payload
    },
    SET_FILTERS_OPTIONS: (state, { payload: { roles } }) => {
      state.optionsPerFilter.roles = roles
    },
    SET_USERS_FILTERS: (state, { payload: { name, filterVal, comparator, filterType } }) => {
      state.query.filters[name] = { filterVal, filterType, comparator }
    },
    CLEAN_USERS_FILTERS: (state) => {
      state.query.filters = {}
    },
    SET_SIZE_PER_PAGE: (state, payload) => {
      state.query.sizePerPage = payload
    }
  },
  extraReducers: (builder) => {
    builder.addCase(HYDRATE, (state, action) => {
      if (action.payload.users) {
        return {
          ...state,
          ...action.payload.users
        }
      }
      return state
    })
  }
})

const selectFilters = (state) => state.users.query.filters

const selectFilterValues = createSelector([selectFilters], (filters) =>
  Object.keys(filters || {}).map((key) => ({ key, value: filters[key].filterVal }))
)
export default users

export const usersActions = users.actions

export const usersSelectors = {
  selectUsers: (state) => state.users,
  selectFilters,
  selectFilterValues
}
